const authorizedFileExtensions = [
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
  '.bmp',
  '.xlsx',
  '.docx',
  '.txt',
];

const pdfFileExtension = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
];

const consumerMessageFileExtension = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.xlsx',
  '.xls',
];

export { authorizedFileExtensions, pdfFileExtension, consumerMessageFileExtension };
